import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { onBasePath } from '../../paths/onBasePath';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './Relations.translations.json';
import { SectionContextProvider } from '../../common/SectionContext';
import { NotFound } from '../NotFound';
import { RelationsDirectory } from './RelationsDirectory';

const { addTranslations, Translation } = i18nNsFactory('relations');
addTranslations(translations);

export const RELATIONS_ROUTES = [
  {
    path: '/',
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.relations')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <RelationsDirectory />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export interface RelationsProps {
  basePath: string;
}

export const Relations: FC<RelationsProps> = ({ basePath }) => (
  <SectionContextProvider basePath={basePath}>
    {useRoutes(onBasePath(basePath, RELATIONS_ROUTES))}
  </SectionContextProvider>
);
